import React from "react";
import { useFela } from "react-fela";

import { useTheme } from "@/hooks/useTheme";
import { Grid } from "@/components/Grid";
import { ListElement } from "@/components/ListElement";
import { Heading } from "@/components/Heading";
import { Image } from "@/components/Image";
import { LinkButton } from "@/components/LinkButton";
import Oval from "@/icons/oval-copy-10.svg";

import { IApiTeaserSection } from "./types";

type IProps = IApiTeaserSection & JSX.IntrinsicElements["div"];

export const ApiTeaserSection: React.FC<IProps> = ({
  elements = [],
  title,
  image,
  backgroundColor = "#fff",
  cta,
  ...rest
}) => {
  const { css } = useFela();
  const { bp, colors } = useTheme();

  return (
    <Grid
      customStyle={{
        flexDirection: "column",
        [bp.FROM_DESKTOP]: {
          flexDirection: "row",
          justifyContent: "space-between",
        },
      }}
      wrapperStyle={{ position: "relative", backgroundColor }}
      id="ApiTeaserSection"
      {...rest}
    >
      <div
        className={css({
          position: "absolute",
          bottom: 0,
          left: 0,
          display: "none",
          [bp.FROM_LARGE_DESKTOP]: {
            display: "block",
          },
        })}
      >
        <Oval />
      </div>
      <div
        className={css({
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        })}
      >
        <div
          className={css({
            width: "60%",
            marginBottom: 20,
            [bp.FROM_DESKTOP]: {
              width: "100%",
              maxWidth: 460,
              marginBottom: 0,
              marginRight: "auto",
              transform: "translateY(0)",
            },
            [bp.FROM_LARGE_DESKTOP]: { maxWidth: 580 },
          })}
        >
          <Image
            customStyle={{ maxWidth: "100%", margin: "0 auto" }}
            src={image.src}
            alt={image.alt}
          />
        </div>
      </div>
      <div
        className={css({
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          [bp.FROM_DESKTOP]: { alignItems: "flex-start" },
        })}
      >
        <Heading as="h2">{title}</Heading>

        {elements.length && (
          <ul
            className={css({
              margin: 0,
              padding: 0,
              listStyleType: "none",
            })}
          >
            {elements.map((element, index) => (
              <ListElement
                titleStyle={{ fontSize: 20, lineHeight: 1.3 }}
                textStyle={{
                  fontSize: 18,
                  lineHeight: 1.44,
                  color: colors.GRAY,
                  marginTop: 0,
                  [bp.FROM_DESKTOP]: {
                    marginBottom: 31,
                  },
                }}
                {...element}
                key={`ListElement-${index}`}
              />
            ))}
          </ul>
        )}

        {cta && (
          <LinkButton customStyle={{ width: "auto", marginTop: 45 }} {...cta} />
        )}
      </div>
    </Grid>
  );
};
